module.exports = __webpack_public_path__ + "media/images/bikini-a8d6fd48a364a9bcef8b279f6556668e.jpg";